import { chakra, Input, InputGroup, InputLeftElement, InputProps } from "@chakra-ui/react";
import React from "react";
import classNames from "classnames";
import Icon from "@/components/Icon";
import { ReactComponent as SearchSvg } from "@/assets/icons/search.svg";
import { langStore, translate } from "@noli/business";
import { Editor_Gallery_Words } from "@/utils/lang";
import { genBlock } from "@/utils/bem";
import { observer } from "mobx-react-lite";

interface SearchProps extends Omit<InputProps, "onChange"> {
  onSearch?: (keyword?: string) => void;
  onChange?: (value?: string) => void;
}
const block = genBlock("c-search");
const ISearch = React.forwardRef<HTMLInputElement, SearchProps>(
  ({ placeholder, onSearch, onChange, className, h = "28px", ...inputProps }, ref) => {
    const lang = langStore.tgt;
    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const value = (e.target as any).value as string;
      onSearch?.(value);
    };

    return (
      <InputGroup size="sm" h={h} className={classNames(className, block())}>
        <InputLeftElement h={h} pointerEvents="none" className={block({ e: "left" })}>
          <Icon
            className={block({ e: "icon-search" })}
            svg={SearchSvg}
            fontSize="16px"
            color="text.secondary"
          />
        </InputLeftElement>
        <Input
          ref={ref}
          size="sm"
          h={h}
          fontSize="12px"
          color="text.input"
          bg="transparent"
          borderColor="text.secondary"
          rounded="4px"
          _hover={{ borderColor: "brand.primary" }}
          _placeholder={{ color: "text.secondary", opacity: 0.4 }}
          _focusVisible={{ borderColor: "brand.active" }}
          onChange={(e) => {
            onChange?.((e.target as any).value);
          }}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              // 回车
              handleSearch(e);
            }
          }}
          className={block({ e: "input" })}
          placeholder={placeholder ?? translate(Editor_Gallery_Words["search-placeholeder"], lang)}
          {...inputProps}
        />
      </InputGroup>
    );
  },
);

export const Search = chakra(observer(ISearch));
